import * as React from 'react';

import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { Res, PaymentDTO } from 'core/api';
import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { Result } from 'core/infrastructure';
import { Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = { previousNotes: string } & Modal.Actions<string>;
type State = { note: string };

class GetPaymentNotes extends PosScreenClassComponent<Props, State> {
	private form = React.createRef<UI.Form<State>>();

	createInitialState(props: Props): Nullable<State> {
		return { note: props.previousNotes };
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	protected useKeypad() {
		return false;
	}

	protected getScreenId(): string {
		return 'GET_PAYMENT_NOTES';
	}

	protected getTitle(): string {
		return Res.Web.PAYMENT_CONTROL_SET_NOTES_TITLE();
	}

	protected getImage(): string | SvgIcon {
		return Images.Edit;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({ onOK: this.onOk });
	}

	private onOk = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid)
			this.close(this.state.note);
	};

	protected getContent(): React.ReactNode {
		const { Form, TextBox } = UI.controlsFor<State>();

		return <Form ref={this.form} model={this.state}>
			<Cols>
				<Col width='*'>
					<TextBox placeholder={Res.Web.PAYMENT_CONTROL_NOTE_PLACEHOLDER()} linkTo={x => x.note} lines={15} />
				</Col>
			</Cols>
		</Form>;
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}
}

export default async function getPaymentNotes(paymentMethod: PaymentDTO): Promise<Result<string>> {
	const notesResult = await Modal.show(GetPaymentNotes, { previousNotes: paymentMethod.ExtraInformation });

	if (!notesResult.ok)
		return Result.error();

	return Result.ok(notesResult.value);
}